module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/testimonials/daniel-yam-52390418733cbd81687aa6a47812c236.jpg";